//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './ProjectSignerClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type SearchProjectSignerQueryParameters = {
  projectId?: number | null | undefined ;
  projectRoleId?: number | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export type GetProjectSignerQueryParameters = {
  id: number ;
}

export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/project-signers";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'ProjectSignerClient',
      'create',
    ]);
}

export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.ProjectSignerDto, unknown, Types.ProjectSignerCreateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ProjectSignerDto, unknown, Types.ProjectSignerCreateDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.ProjectSignerCreateDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function searchUrl(projectId?: number | null | undefined, projectRoleId?: number | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/project-signers?";
if (projectId !== undefined && projectId !== null)
    url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
if (projectRoleId !== undefined && projectRoleId !== null)
    url_ += "ProjectRoleId=" + encodeURIComponent("" + projectRoleId) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchDefaultOptions: Omit<UseQueryOptions<Types.PagedResultOfProjectSignerDto, unknown, Types.PagedResultOfProjectSignerDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultOfProjectSignerDto, unknown, Types.PagedResultOfProjectSignerDto>, 'queryFn'>> = {
};
export function getSearchDefaultOptions() {
  return searchDefaultOptions;
};
export function setSearchDefaultOptions(options: typeof searchDefaultOptions) {
  searchDefaultOptions = options;
}

export function searchQueryKey(dto: SearchProjectSignerQueryParameters): QueryKey;
export function searchQueryKey(projectId?: number | null | undefined, projectRoleId?: number | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function searchQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { projectId, projectRoleId, offset, limit, sortBy, sortOrder,  } = params[0] as SearchProjectSignerQueryParameters;

    return trimArrayEnd([
        'ProjectSignerClient',
        'search',
        projectId as any,
        projectRoleId as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'ProjectSignerClient',
        'search',
        ...params
      ]);
  }
}
export function __search(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.search(
      context.queryKey[2] as number | null | undefined,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as number | null | undefined,       context.queryKey[5] as number | null | undefined,       context.queryKey[6] as string | null | undefined,       context.queryKey[7] as Types.SortOrder | undefined,axiosConfig    );
}

export function useSearchQuery<TSelectData = Types.PagedResultOfProjectSignerDto, TError = unknown>(dto: SearchProjectSignerQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultOfProjectSignerDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useSearchQuery<TSelectData = Types.PagedResultOfProjectSignerDto, TError = unknown>(projectId?: number | null | undefined, projectRoleId?: number | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.PagedResultOfProjectSignerDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchQuery<TSelectData = Types.PagedResultOfProjectSignerDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfProjectSignerDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let projectId: any = undefined;
  let projectRoleId: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ projectId, projectRoleId, offset, limit, sortBy, sortOrder,  } = params[0] as SearchProjectSignerQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [projectId, projectRoleId, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultOfProjectSignerDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __search(context, axiosConfig) : __search,
    queryKey: searchQueryKey(projectId, projectRoleId, offset, limit, sortBy, sortOrder),
    ...searchDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultOfProjectSignerDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setSearchData(queryClient: QueryClient, updater: (data: Types.PagedResultOfProjectSignerDto | undefined) => Types.PagedResultOfProjectSignerDto, projectId?: number | null | undefined, projectRoleId?: number | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(searchQueryKey(projectId, projectRoleId, offset, limit, sortBy, sortOrder),
    updater
  );
}

export function setSearchDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfProjectSignerDto | undefined) => Types.PagedResultOfProjectSignerDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/project-signers/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.ProjectSignerDto, unknown, Types.ProjectSignerDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ProjectSignerDto, unknown, Types.ProjectSignerDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(id: number): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetProjectSignerQueryParameters;

    return trimArrayEnd([
        'ProjectSignerClient',
        'get',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'ProjectSignerClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.ProjectSignerDto, TError = unknown>(dto: GetProjectSignerQueryParameters, options?: Omit<UseQueryOptions<Types.ProjectSignerDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useGetQuery<TSelectData = Types.ProjectSignerDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.ProjectSignerDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.ProjectSignerDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ProjectSignerDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetProjectSignerQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ProjectSignerDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(id),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.ProjectSignerDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setGetData(queryClient: QueryClient, updater: (data: Types.ProjectSignerDto | undefined) => Types.ProjectSignerDto, id: number) {
  queryClient.setQueryData(getQueryKey(id),
    updater
  );
}

export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ProjectSignerDto | undefined) => Types.ProjectSignerDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function verifySignersUpdateAbilityUrl(): string {
  let url_ = getBaseUrl() + "/api/project-signers/update-signers/verify";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function verifySignersUpdateAbilityMutationKey(): MutationKey {
  return trimArrayEnd([
      'ProjectSignerClient',
      'verifySignersUpdateAbility',
    ]);
}

/**
 * If the most priority signer changes, returns the list of document names, that will be invalidated.
 */
export function useVerifySignersUpdateAbilityMutation<TContext>(options?: Omit<UseMutationOptions<string[], unknown, Types.UpdateProjectSignersDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<string[], unknown, Types.UpdateProjectSignersDto, TContext> {
  const key = verifySignersUpdateAbilityMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.UpdateProjectSignersDto) => Client.verifySignersUpdateAbility(dto),
    mutationKey: key,
  });
}
  
export function updateSignersUrl(): string {
  let url_ = getBaseUrl() + "/api/project-signers/update-signers";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateSignersMutationKey(): MutationKey {
  return trimArrayEnd([
      'ProjectSignerClient',
      'updateSigners',
    ]);
}

export function useUpdateSignersMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.UpdateProjectSignersDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.UpdateProjectSignersDto, TContext> {
  const key = updateSignersMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.UpdateProjectSignersDto) => Client.updateSigners(dto),
    mutationKey: key,
  });
}